/** Base path of the react-admin panel (must match `<Admin basename>`). */
export const ADMIN_BASE = "/admin";

export const ADMIN_LOGIN = `${ADMIN_BASE}/login`;
